import "codemirror/addon/mode/simple";
import { Pane, Splitpanes } from 'splitpanes'

import $ from "jquery";
import AjaxUtils from "../../util/ajax_utils";
import { ApckAccordion } from "../common/accordion";
import { ApckPropertyTable } from "../common/property_table";
import CodeMirror from "codemirror";
import getCookie from "../../util/getcookie";
import { cleanHostName, createUUIDv4, isIPAddress } from "../../util/helpers";
import { ApckGoScriptScope } from "./goscript_scope";
import { ApckPlaceholder } from "../common/placeholder";
import { isEmpty } from "lodash";
import { GoScriptWizardModal } from "./goscript_wizard";
import { ApckLogConsole } from "../common/log_console";
import { ApckGoScriptTemplateModal, getGoScriptTemplateByName } from "./templates";
import { ApckGoScriptAuthProfile } from "./goscript_auth_profile";
import { ApckGoScriptVariables, ApckGoScriptNetworkCredentials } from "./goscript_credentials";
import { ApckNarrative, ModalScreencastGallery } from "./narrative";
import { ApckGoScriptDiffModal } from "./goscript_modal";
import { GOSCRIPT_MODE } from "./goscript_mode";


function getRestoreJobMessage(command) {
    let message = "Restore latest job result?";
    if (command === "test"){
        message = "Restore the latest script testing result? GoScript will be restored to the state it was in when the job ran."
    }
    if (command === "generate"){
        message = "Restore the latest script generation result?. GoScript will be restored to the state it was in when the job ran."
    }
    if (command === "fix"){
        message = "Restore the latest script fix result? . GoScript will be restored to the state it was in when the job ran."
    }
    if (command === "analyse"){
        message = "Restore the latest auth analysis result? GoScript will be restored to the point at which the job was run."
    }
    return message;
}

export const GoScriptGenerateModal = {
    components: {
        'apck-accordion': ApckAccordion,
        'apck-goscript-variables': ApckGoScriptVariables,
        'apck-goscript-network-credentials': ApckGoScriptNetworkCredentials,
        'apck-goscript-scope': ApckGoScriptScope,
    },
    props: {
        activeScript: {
            type: Object,
            default: {},
        },
        protectedKeys: {
            type: Array,
        },
        isFixingScript: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        enableCredentialService: function() {
            if (this.$permissions?.enable_credential_service) return true;
            return false;
        },
        actionLabel: function() {
            if (this.isFixingScript) return "Fix Script";
            return "Generate Script";
        }
    },
    methods: {
        // TODO: move to the mixin
        isPropertyRequired: function (property_required) {
            for (let index = 0; index < property_required.length; index++) {
                const element = property_required[index];
                if (!this.activeScript.variables[element]) {
                    var message = `Please provide a value for ${element} in the Variables table.`;
                    var flash = this.$dialog.alert(message, 'Validation Error');
                    return false;
                }
            }
            return true;
        },
        accept() {
            if (!this.isPropertyRequired(['login_url', 'username', 'password'])) {
                return
            }
            this.$emit('generate');
            this.$emit('close');
        },
        deny() {
            this.$emit('close');
        },
    },
    template: `
        <div>
            <p>To begin, please provide the following information to generate your login script automatically: Login Page URL, Username, and Password. Ensure you have the necessary credentials and access rights to proceed.</p>
            <apck-accordion title="Variables">
                <apck-goscript-variables
                    :active-script="activeScript"
                    :enable-credential-service="enableCredentialService"
                    :protected-keys="protectedKeys"
                />
            </apck-accordion>
            <apck-accordion
                v-if="enableCredentialService"
                title="Network Credentials"
                :collapsed="true"
            >
                <apck-goscript-network-credentials
                    :active-script="activeScript"
                />
            </apck-accordion>
            <apck-accordion
                title="Scope"
                :collapsed="true"
            >
                <p>Any login URL entered above will be automatically added to the scope. If you want to include additional scopes, you can add them below.</p>
                <apck-goscript-scope
                    v-model="activeScript.scope"
                    confirmation-message="Are you sure you want to delete the scope host"
                    confirmation-empty-message="Are you sure you want to delete the unnamed scope host?"
                    confirmation-item="scope host"
                    :selected-values.sync="activeScript.scope_selected_values"
                />
                <p>This list is for analysis purposes only, for accurate results it must correspond to the scope specified within the scan configuration and therefore must fall within your organisation's scope.</p>

            </apck-accordion>
            <div class="pull-right">
                <span class="btn-positive btn" v-on:click="accept">{{actionLabel}}</span>
                <span class="btn-negative btn" v-on:click="deny">Cancel</span>
            </div>

        </div>
    `
}

export const GoScriptScopeModal = {
    components: {
        'apck-goscript-scope': ApckGoScriptScope,
    },
    props: {
        activeScript: {
            type: Object,
            default: {},
        },
    },
    methods: {
        accept() {
            this.$emit('skip');
            this.$emit('close');
        },
        deny() {
            this.$emit('close');
        },
    },
    template: `
        <div class="">
            <p>You haven't selected any scope hosts. Proceeding without selecting any may result in an analysis failure. Please select a scope to continue.</p>
            <hr />
            <apck-goscript-scope
                v-model="activeScript.scope"
                confirmation-message="Are you sure you want to delete the scope host"
                confirmation-empty-message="Are you sure you want to delete the unnamed scope host?"
                confirmation-item="scope host"
                :selected-values.sync="activeScript.scope_selected_values"
            />
            <p>This list is for analysis purposes only, for accurate results it must correspond to the scope specified within the scan configuration and therefore must fall within your organisation's scope.</p>
            <div class="pull-right">
                <span class="btn-positive btn-short btn" v-on:click="accept">Continue</span>
                <span class="btn-negative btn-short btn" v-on:click="deny">Cancel</span>
            </div>
        </div>
    `
}

export const ApckSnapshotsModal = {
    props: {
        events: {
            type: Array,
            default: [],
        },
        snapshotId: {
            type: String,
            default: '',
        },
    },
    data: function () {
        return {
            active: 0,
        };
    },
    methods: {
        closeModal: function () {
            // lightbox callback before close
            this.$emit('close');
        },
        next: function () {
            if (this.active == this.images.length - 1) this.active = 0;
            else this.active += 1;
        },
        prev: function () {
            if (this.active == 0) this.active = this.images.length - 1;
            else this.active -= 1;
        },
    },
    computed: {
        images() {
            return this.events.filter((item) => item.type === 'snapshot');
        },
        imgSrc: function () {
            return this.images[this.active].data;
        },
        commandInfo: function () {
            // Search the previous element before the snapshot to get info
            const cmp = this;
            const snapshot_index = cmp.events.findIndex((f) => f.id === cmp.images[cmp.active].id);
            for (let i = snapshot_index - 1; i >= 0; i--) {
                if (cmp.events[i].type?.startsWith("log_")) return cmp.events[i];
            }
        },
        snapshotNumber: function () {
            return this.active + 1;
        },
        snapshotTotal: function () {
            return this.images.length;
        },
    },
    mounted: function () {
        if (this.snapshotId) {
            const snapshot_index = this.images.findIndex((f) => f.id === this.snapshotId);
            this.active = snapshot_index;
        }
    },
    template: `
        <div ref="image_modal" class="snapshots-modal">
        <div class="snapshots-modal__container">
            <img
                :src="imgSrc"
                class="snapshots-modal__container__image"
                v-on:click="next"
            />
            <div v-if="commandInfo.group" class="snapshots-modal__container__function">
                <span>{{commandInfo.group}}</span>
            </div>
            <div class="snapshots-modal__container__pagination">
                <apck-button
                    title="prev"
                    icon="fa-angle-left"
                    class="btn-primary btn-big"
                    :handler="prev"
                />

                <apck-button
                    title="next"
                    icon="fa-angle-right"
                    class="btn-primary btn-big"
                    :handler="next"
                />
            </div>
            <div
                class="snapshots-modal__container__expand"
            >
                <a
                    :href="imgSrc"
                    class="btn btn-primary btn-big"
                    target="_blank"
                >
                    <i class="fa fa-external-link"></i>
                </a>

            </div>
        </div>

            <div v-if="commandInfo" class="snapshots-modal__data">
                <div class="snapshots-modal__data__content">
                    <div>
                        <span>{{snapshotNumber}} of {{snapshotTotal}}</span>
                        <i>{{commandInfo.timestamp}}</i>
                    </div>{{commandInfo.data}}
                </div>
            </div>
        </div>
    `,
};

export const ApckSnapshotsGallery = {
    // Deprecated because snapshots are rendered from narrative items.
    props: {
        events: {
            type: Array,
            default: [],
        },
    },
    data: function () {
        return {
            showModal: false,
            funcName: '',
        };
    },
    computed: {
        snapshots() {
            const cmp = this;
            if (this.funcName)
                return this.events.filter(
                    (item) => item.type === 'snapshot' && item.group === cmp.funcName,
                );
            return this.events.filter((item) => item.type === 'snapshot');
        },
        groupedItems() {
            return this.events.reduce((accumulator, item) => {
                if (item.type === 'snapshot') {
                    if (!accumulator[item.group]) {
                        accumulator[item.group] = [];
                    }
                    accumulator[item.group].push(item);
                }
                return accumulator;
            }, {});
        },
    },
    methods: {
        clickImage: function (snapshotId) {
            this.showModal = true;

            this.$lightbox.open({
                title: 'Snapshots',
                size: 'snapshot',
                position: 'top',
                component: ApckSnapshotsModal,
                bind: {
                    events: this.events,
                    'snapshot-id': snapshotId,
                },
            });
        },
        closeModal: function () {
            this.showModal = false;
        },
    },
    mounted: function () {
        this.showModal = false;
    },
    template: `
        <div class="snapshots">
            <div v-for="(items, functionName) in groupedItems" :key="functionName">
                <div v-if="functionName" class="goscript-bottom__title">{{ functionName }} </div>
             <a
                href="javascript:"
                v-on:click="clickImage(item.id)"
                v-for="item in items"
            >
                <img
                    :src="item.data"
                />
            </a>
            </div>
        </div>
    `,
};

export const ApckScreencastThumbnails = {
    props: {
        events: {
            type: Array,
            default: [],
        },
        attachmentUrl: {
            type: String,
            default: '/vuln-control/attachment',
        },
    },
    computed: {
        sortedEvents() {
            // Returns `events` re-ordered so that each item sits where it actually
            // happened in the run, rather than where it landed in the narrative.
            //
            // Two timestamps are at play here:
            // 1. The event timestamp (event.timestamp)
            // 2. narrativeNode.timestamp
            //
            // Since narrtive processing takes a while, these timestamps may not match up.
            // We use narrativeNode.timestamp when available, and fall back to event.timestamp otherwise.
            const key = (event) => {
                const node = event.narrativeNode;
                if (node?.type === 'uploaded_evidence' && typeof node.timestamp === 'number') {
                    return node.timestamp;
                }
                return Date.parse(event.timestamp) / 1000;
            };
            return this.events
                // Wrap each event in a new object with the timestamp that we're using
                .map((event, index) => ({ event, index, ts: key(event) }))
                // Sort based on this timestamp
                .sort((a, b) => (a.ts - b.ts) || (a.index - b.index))
                // Unwrap the event from the object we just created
                .map(({ event }) => event);
        },
        groupedItems() {
            let chapter = null;
            let scene = null;
            return this.sortedEvents.reduce((acc, event) => {
                if (event.type !== 'narrative_item' || !event.narrativeNode) return acc;
                const node = event.narrativeNode;
                if (node.type === 'chapter') {
                    chapter = node;
                    scene = null;
                }
                if (node.type === 'scene') {
                    scene = node;
                }
                if (node.serialised === 'ScreencastFrame') {
                    const label = [chapter?.title, scene?.title].filter(Boolean).join(' / ');
                    if (!acc[label]) {
acc[label] = [];
                    }
                    acc[label].push(node);
                }
                return acc;
            }, {});
        },
    },
    methods: {
        clickImage: function (item) {
            this.$modal.open({
                title: 'Screencast',
                component: ModalScreencastGallery,
                bind: {
                    events: this.events,
                    'attachment-url': this.attachmentUrl,
                    'start-id': item.object_path,
                },
                fullHeight: true,
                size: 'lg',
            });
        },
    },
    template: `
        <div class="new-ui">
            <ui-layout direction="column" gap="2">
                <ui-layout v-for="(items, groupName) in groupedItems" :key="groupName" direction="column" gap="1">
                    <ui-heading class="padding-2">{{ groupName }}</ui-heading>                    
                    <ui-layout gap="2" wrap>
                        <ui-image
                            v-for="(item, index) in items"
                            :key="index"
                            :src="item.download_url"
                            placeholder="Loading..."
                            size="xs"
                            :handler="() => clickImage(item)"
                        />
                    </ui-layout>
                </ui-layout>
            </ui-layout>
        </div>
    `,
};

export const ApckGoScriptTable = {
    data: function () {
        return {
            cols: [
                { "data": "name", "heading": "Name", "canSearch": true },
                { "data": "type", "heading": "Type", "canSearch": true }
            ],
            actions: [{
                title: "Delete",
                icon: "fa-trash",
                class: "btn-negative",
                handler: this.delete
            }]
        };
    },
    methods: {
        rowclick: function (rec) {
            var _id = rec.get('_id');
            if (_id) {
                this.$router.push({
                    name: 'goscript.edit',
                    params: {
                        script_id: _id
                    }
                });
            }
        },
        delete: function (rec) {
            var _id = rec.get('_id');
            if (_id) {
                this.$dialog.confirm(
                    'Are you sure you want to delete this GoScript?',
                    'Delete GoScript',
                    function () {
                        /*
                        AjaxUtils.ajax_post({
                            url: '/goscript/delete/' + _id,
                            success: function (data) {
                                this.$dialog.alert(
                                    'GoScript has been deleted successfully',
                                    'GoScript Deleted'
                                );
                            }, fail: function () {
                                this.$dialog.alert(
                                    'Failed to delete the goscript!',
                                    'GoScript failed'
                                );
                            }
                        });
                        */
                    }
                );
            }
        }
    },
    template: `
        <apck-table title="GoScripts" :columns="cols" src="/goscript" :row-action="rowclick" :actions="actions" />
    `
}

export const ApckGoScriptJobHistory = {
    props: {
        url: {
            type: String,
        },
    },
    components: {
        'apck-placeholder': ApckPlaceholder,
    },
    data: function () {
        return {
            showScriptList: false,
            cols: [
                    {"center": true, "ctype": "datecolumn", "width": 140, "canSearch": false, "data": "created", "heading": "Created"},
                    {"center": true, "ctype": "column", "width": 140, "canSearch": false, "data": "command", "heading": "Job"},
                    {"center": true, "ctype": "column", "width": 140, "canSearch": false, "data": "status", "heading": "Status"},
                    {"center": true, "ctype": "column", "width": 140, "canSearch": false, "data": "job_id", "heading": "ID"},
                    // {"center": true, "ctype": "boolcolumn", "width": 140, "canSearch": false, "data": "error", "heading": "Error"},
                ],
            scriptName: "",
            actions: [
                {
                    title: "Select",
                    icon: "fa-crosshairs-simple",
                    class: "btn-primary",
                    handler: this.selectJob,
                },
            ],

        };
    },
    mounted () {
    },
    methods: {
        selectJob: function (rec) {
            const cmp = this;

            const job_id = rec.get("job_id");
            const command = rec.get("command");
            let message = getRestoreJobMessage(command);
            cmp.$dialog.confirm(
                message,
                'Job History',
                function () {
                    cmp.$emit("restore", job_id);
                }
            )
        },
        reload() {
            this.$refs.table.store.reload();
        }
    },
    template: `
        <div class="new-ui">
            <apck-table
                ref="table"
                :columns="cols"
                :src="url"
                :sgl-row-action="selectJob"
                :show-toolbar="false"
                :show-page-bar="false"
                :hide-sort="true"
                :new-style-table="true"
            />
        </div>
    `,
};

export const ApckGoScriptEditor = {
    components: {
        'apck-property-table': ApckPropertyTable,
        'apck-goscript-scope': ApckGoScriptScope,
        'apck-accordion': ApckAccordion,
        'apck-snapshots-gallery': ApckSnapshotsGallery,
        'apck-screencast-thumbnails': ApckScreencastThumbnails,
        'apck-log-console': ApckLogConsole,
        'apck-goscript-auth-profile': ApckGoScriptAuthProfile,
        'splitpanes': Splitpanes,
        'pane': Pane,
        'apck-placeholder': ApckPlaceholder,
        'apck-goscript-variables': ApckGoScriptVariables,
        'apck-goscript-network-credentials': ApckGoScriptNetworkCredentials,
        'apck-narrative': ApckNarrative,
        'apck-goscript-job-history': ApckGoScriptJobHistory,
        },
    props: {
        goscript: {
            type: Object,
            default: function () {
                return {
                    _id: null,
                    name: '',
                    script: '',
                    type: 'auth',
                    variables: {},
                    headers: {},
                    basic_credential_id: '',
                    digest_credential_id: '',
                    ntlm_credential_id: '',
                };
            },
        },
        pollInterval: {
            type: Number,
            default: 15000,
        },
        isStandalone: {
            type: Boolean,
            default: false,
        },
        exchanges: {
            type: Array,
            default: function () {
                return [];
            },
        },
    },
    created: function () {
        window.addEventListener("resize", this.resizedPane);

        $.ajaxSetup({
            headers: { 'X-CSRF-Token': getCookie('csrftoken') }
        });

        CodeMirror.defineSimpleMode("goscript", GOSCRIPT_MODE);
    },
    computed: {
        title: function () {
            if (this.isStandalone) return "";
            var t = 'New GoScript:';
            if (this.activeScript._id) {
                t = "Editing GoScript: " + this.activeScript.name;
            }
            return t;
        },
        url: function () {
            var url = '/goscript/new';
            if (this.activeScript._id) {
                url = '/goscript/' + this.activeScript._id;
            }
            return url;
        },
        jobListUrl: function () {
            var url = '/goscript/job/list/';
            if (this.activeScript._id) {
                url = '/goscript/job/list/' + this.activeScript._id;
            }
            return url;
        },
        protectedKeys: function () {
            return ["username", "password"];
        },
        isAuthType: function () {
            return this.activeScript.type === 'auth';
        },
        enableGoscriptWizard: function() {
            if (this.$permissions?.enable_goscript_wizard) return true;
            return false;
        },
        enableCredentialService: function() {
            if (this.$permissions?.enable_credential_service) return true;
            return false;
        },
        enableGoscriptAI: function() {
            if (this.$permissions?.enable_goscript_ai) return true;
            return false;
        },
        isSuperAdmin: function() {
            if (this.$permissions?.superadmin_group) return true;
            return false;
        },
        profileBadgeClass() {
            // Add a badge to the Auth Profile tab
            const styleMap = {
                'auth detected': 'positive',
                'auth mechanism not determined': 'warning',
            };
            const lowerValue = this.authProfileMessage.toLowerCase();

            for (const [key, style] of Object.entries(styleMap)) {
                if (lowerValue.includes(key)) {
                    return style;
                }
            }
            return '';
        },
        hasLlmEvents() {
            return this.llmEvents.length > 0;
        },
        screencastEvents() {
            if (this.hasLlmEvents) {
                return this.llmEvents;
            }

            return this.events;
        },        
        hasLogEvents() {
            return this.events.length > 0;
        },
        llmRunningIcon() {
            if (this.llmRunning) return ["fa-spinner", "fa-spin"];
        },
        showRunningMask() {
            // Show the running mask while running, unless LLM output is already shown.
            if (!this.running) return false;
            if (this.llmRunningMask) return true;
            return !this.llmRunning;
        },
        canUsePrivateHub() {
            // For now, we can only run LLMs on public hubs,
            // except for the admin group.
            if (this.exchange) {
                if (this.$permissions?.superadmin_group) return true;
                return false;
            }
            return true;
        }
    },
    data: function () {
        var test_script = getGoScriptTemplateByName('auth');
        var script = this.goscript.script ? this.goscript.script : test_script;

        return {
            maxRetriesOnFail: 2,
            progress: 0,
            events: [],
            llmEvents: [],
            placeholder: script,
            exchange: '',
            codemirror: null,
            activeScript: this.goscript,
            llmRunningMask: false,
            llmRunning: false,
            running: false,
            runningName: "Please wait",
            // status bar
            statusStatus: "",
            statusResult: "",
            statusCommand: "",
            console: [],
            bottomHeight: 0,
            sidebarHeight: 0,
            initialPaneSize: 25,
            paneSize: 25,
            activeTab: 0,
            headersRegex: new RegExp('[^\\w-]', 'g'),
            isScriptChanged: false,
            skipVarValidation: false,
            skipLoginAgainValidation: false,
            skipScopeSelectedValuesValidation: false,
            skipAnyScopeSelectedValidation: false,
            missingVariablesList: [],
            authProfile: {},
            authProfileMessage: "",
            lineErrorNo: null,
            scopeValidationResults: [],
            pollBigInterval: 30000,
            narrative: null,
            wizardStatus: {
                test: false,
                analyse: false,
                generate: false,
                testName: "",
                analyseName: "",
                generateName: "",
                running: false,
                runningName: "",
                progress: 0,
                exchange: "",
                command: "",
            },
            jobsToSave: [],
        };
    },
    watch: {
        goscript: function (val) {
            this.activeScript = val;
            this.codemirror.setValue(val.script);
            this.jobsToSave = [];
        }
    },
    mounted: function () {
        this.$nextTick(function () {
            this.codemirror = CodeMirror(this.$refs.scriptEditor, {
                value: this.placeholder,
                mode: "goscript",
                lineNumbers: true,
                gutters: ["CodeMirror-linenumbers", "breakpoints"]
            });
            this.codemirror.setSize("100%", "100%");
            this.codemirror.on('change', this.changeGoScript);
        });

        // calc bottom height, initially 50%
        const bHeight = this.$refs.goscriptBottom.getBoundingClientRect().height
        this.initialPaneSize = Math.round(15200 / (bHeight*2));
        if (this.initialPaneSize > 25) this.initialPaneSize = 25;
        this.paneSize = this.initialPaneSize;
        this.$nextTick(function () {
            this.loadLocalStorage();
        });
    },
    destroyed() {
        window.removeEventListener("resize", this.resizedPane);
    },
    methods: {
        checkLatestJob: function(jobId=null) {
            return new Promise((resolve) => {
                const cmp = this;
                AjaxUtils.ajax_post({
                    url: cmp.jobListUrl,
                    success: function (data) {
                        if (data && data.items && data.items.length > 0) {
                            let jobItem;
                            if (jobId) {
                                // Check for the latest job from the unsaved script.
                                jobItem = data.items.find(function (item) { return item.job_id === jobId; });
                                // If that job is not found and the script is saved fall back to the latest job.
                                if (!jobItem && cmp.activeScript._id) {
                                    jobItem = data.items[0];
                                }
                            } else {
                                jobItem = data.items[0];
                            }

                            if (!jobItem) {
                                resolve(false);
                                return;
                            }
                            const message = getRestoreJobMessage(jobItem.command);
                            cmp.$dialog.confirm(
                                message,
                                'Job History',
                                function () { cmp.restoreJob(jobItem.job_id); resolve(true); },
                                function () { resolve(false); }
                            );
                        } else {
                            resolve(false);
                        }
                    },
                    fail: function () {
                        resolve(false);
                    },
                });
            });
        },
        restoreJob: function (jobId) {
            this.clearLog();
            const url = `/goscript/job/details/${jobId}`;
            const cmp = this;
            AjaxUtils.ajax_post({
                url: url,
                success: function (data) {
                    cmp.events = [];
                    const json = data.data;

                    if (!json) {
                        cmp.$flash({
                            type: 'error',
                            message: "Couldn't restore the job. Please try again."
                        });
                        return
                    }

                    cmp.log("id: " + json.job_id);

                    let message = "";
                    cmp.statusResult = '';
                    cmp.authProfileMessage = "";

                    if (json.script)
                        cmp.codemirror.setValue(json.script);

                    if ('events' in json) {
                        cmp.updateEvents(json.events);
                    };

                    if (!cmp.activeScript._id) {
                        // If we restore a job for an unsaved GoScript, we add it to the list to be saved.
                        cmp.jobsToSave.push(json.job_id);
                    }                    

                    if (["ongoing", ""].includes(json.status)) {
                        if (json.command === "test") { cmp.testScriptJob(json.job_id); }
                        if (json.command === "analyse") { cmp.analyseScriptJob(json.job_id); }
                        if (json.command === "generate") { cmp.generateScriptJob(json.use_agentic || false, json.job_id); }
                        if (json.command === "fix") { cmp.generateScriptJob(json.use_agentic || false, json.job_id, true); }
                        return
                    }

                    if (["completed", "complete"].includes(json.status)) {
                        cmp.log("status: complete", "log_notice");
                        cmp.statusStatus = 'complete';
                        if (json.error) {
                            cmp.statusResult = 'error';
                            if (json.message) {
                                cmp.$flash({
                                    type: 'error',
                                    message: json.message
                                });
                            }

                        }
                        else {
                            cmp.statusResult = 'success';
                        }
                        if (json.command === "generate") {
                            cmp.onGenerateComplete(json);
                        }
                        if (json.command === "fix") {
                            cmp.onGenerateComplete(json);
                        }
                        if (json.command === "test") {
                            cmp.onTestComplete(json);
                        }
                        if (json.command === "analyse") {
                            cmp.onAnalyseComplete(json);
                        }

                        cmp.updateRunning(false);
                        cmp.highlightLogError();

                    }
                },
            });
        },
        handleAuthNarrative: function (){
            const cmp = this;
            const evidenceItem = cmp.events.find(element => element.type === 'evidence_object_path');
            if (!evidenceItem) return;
            const evidenceObjectPath = evidenceItem.data;
            const url = `/vuln-control/attachment?attachment_id=${encodeURIComponent(evidenceObjectPath)}`;
            AjaxUtils.ajax_get({
                url,
                success: (data) => {
                    const downloadUrl = data['download_url'];
                    AjaxUtils.ajax_get({
                        dataType: 'json',
                        url: downloadUrl,
                        success: (attachmentData) => {
                            if (attachmentData && attachmentData.type === 'narrative') {
                                cmp.narrative = attachmentData;
                            }
                        },
                    });
                },
            });
        },
        openTemplateModal: function (){
            const cmp=this;
            this.$lightbox.open({
                title: 'New GoScript',
                size: 'narrow',
                position: 'top',
                component: ApckGoScriptTemplateModal,
                bind: {
                    "can-use-private-hub": this.canUsePrivateHub,
                },
                on: {
                    generate: function () {
                        cmp.openGenerateModal(true);
                    },
                    wizard: function () {
                        cmp.runWizard();
                    },
                    load: function (template, scriptType) {
                        // TODO:
                        // var message = "Are you sure you want to replace the current script with this template?"
                        // cmp.$dialog.confirm(message, 'Templates', function () {
                        //     cmp.codemirror.setValue(data);
                        // });
                        cmp.codemirror.setValue(template);
                        cmp.activeScript.type = scriptType;
                    },
                },
            });
        },
        updateRunning(val) {
            this.running = val;
            // We use a separate object to pass data to the wizard
            this.wizardStatus.running = val;
            this.wizardStatus.runningName = this.runningName;
            if (this.running) this.progress = 0;
            else this.progress = 100;

            this.wizardStatus.progress = this.progress;

            if (!val) this.llmRunning = false;
        },
        getHubIdByName: function (hubName) {
            // [
            //     {
            //         "hub_id": "scan_hub_1",
            //         "last_updated": 1713786670,
            //         "name": "dev::goscript_runner::22a0730ea0"
            //     }
            // ]
            if (!hubName) return "";
            const exchange = this.exchanges.find(exchange => exchange.name === hubName);
            return exchange ? exchange.hub_id : "";
        },
        getHubNameById: function (hubId) {
            if (!hubId) return ""
            const exchange = this.exchanges.find(exchange => exchange.hub_id === hubId);
            return exchange ? exchange.name : "";
        },
        applyExchange: function (hubId) {
            if (hubId) {
                const hubName = this.getHubNameById(hubId);
                // Set the hub if it can be found
                if (hubName) {
                    this.exchange = hubName;
                    return
                }
                // Get available internal hub
                if (!isEmpty(this.exchanges)) {
                    const newHub = this.exchanges[0];
                    this.exchange = newHub.name;
                    this.$dialog.alert(
                        `The internal hub you were using is not available. You have been automatically switched to ${newHub.hub_id}.`,
                        'Hub Validation'
                    );
                }
                else {
                    // All internal hubs are unavailable.
                    this.exchange = '';
                    this.$dialog.alert(
                        'All internal hubs are unavailable. You have been automatically switched to the Random External Hub',
                        'Hub Validation'
                    );
                }
            }
        },
        loadOrganisationScope: function () {
            const cmp = this;
            AjaxUtils.ajax_post({
                url: '/goscript/scope',
                success: function (data) {
                    if (data.scope) {
                        data.scope.forEach(element => {
                            if (!cmp.activeScript.scope.includes(element)) cmp.activeScript.scope.push(element);
                        });
                        cmp.$flash({ message: 'Organisation Scope has been loaded.' });
                    }
                },
            });
        },
        addEvent: function (data, logType) {
            if (!data) return;
            if (!logType) logType = "log_info"
            this.events.push(
                {
                    type: logType,
                    data: data,
                    id: createUUIDv4()
                }
            )
        },
        updateEvents: function (newEvents) {
            newEvents.forEach(newEvent => {
                if (newEvent.type?.startsWith('ai_')) {
                    const index = this.llmEvents.findIndex(event => event.id === newEvent.id);
                    if (index === -1) {
                        const llmEvent = { ...newEvent,
                            type: newEvent.type.replace(/^ai_/, '')
                        };
                        this.llmEvents.push(llmEvent);
                        this.processScriptEvent(newEvent);
                    }
                } else {
                    const index = this.events.findIndex(event => event.id === newEvent.id);
                    if (index === -1) {
                        this.events.push(newEvent);
                        this.processScriptEvent(newEvent);
                    }
                }
            });
        },
        isRunning: function () {
            if (this.running) {
                this.$dialog.alert(
                    this.runningName,
                    'Validation Error'
                );
                return true
            }
            return false
        },
        isPropertyRequired: function (property_required) {
            for (let index = 0; index < property_required.length; index++) {
                const element = property_required[index];
                if (!this.activeScript.variables[element]) {
                    var message = 'Could you please insert "' + element + '" value into the variables table';
                    var message = `The placeholder {${element}} is used within the script. Please provide a value for ${element} in the Variables table.`;
                    var flash = this.$dialog.alert(
                        message,
                        'Validation Error'
                    );
                    return false;
                }
            }
            return true
        },
        checkRegexLikeVar: function(script) {
            // extract regex like variables
            // /<p>(\d{6})</p>/
            let regexLikeVariables = [];
            const regexRegex = /\/(.*?)\//g;
            let match;
            let regexPatterns = [];
            while ((match = regexRegex.exec(script)) !== null) {
                regexPatterns.push(match[1]);
            }
            const regexVars = /\{(\w+)\}/g;
            regexPatterns.forEach(pattern => {
                while ((match = regexVars.exec(pattern)) !== null) {
                    regexLikeVariables.push(match[1]);
                }
            });
            return regexLikeVariables;
         },
        checkLocalVariables: function(script) {
            // extract local variables
            // myVar := someValue
            // def replacePageContentsWith newContents
            const regexFuncArgs = /def (\w+)(.*?)$/gm;
            const regexLocalVars = /(\w+)(?=\s*:=)/g;
            let funcArgsMatches = script.match(regexFuncArgs);
            let localVarsMatches = script.match(regexLocalVars);
            let localVariables = [];
            if (localVarsMatches) localVariables.push(...localVarsMatches);
            if (funcArgsMatches) {
                funcArgsMatches.forEach(param => {
                    let param_bits = param.trim().split(/\s+/);
                    if (param_bits.length > 2) localVariables.push(...param_bits.slice(2));
                });
            }
            return localVariables;
        },
        validateAnyScopeSelected: function(handler) {
            const cmp = this;
            if (cmp.skipAnyScopeSelectedValidation) return true;
            if (cmp.activeScript.scope_selected_values.length > 0) return true;
            const message = "You haven't selected any scope hosts. Would you like to proceed anyway?"
            this.$lightbox.open({
                title: 'Scope hosts',
                size: 'normal',
                position: 'top',
                component: GoScriptScopeModal,
                bind: {
                    'active-script': cmp.activeScript,
                },
                on: {
                    'skip': function () {
                    cmp.skipAnyScopeSelectedValidation = true;
                    handler();
                }
            }
            });
            return false;
        },
        getSentenceStart(host) {
            return isIPAddress(host) ? 'IP address' : 'host';
        },
        validateScopeSelectedValues: function(handler) {
            const cmp = this;
            if (cmp.skipScopeSelectedValuesValidation) return true;
            if (this.scopeValidationResults.length === 0) return true;
            const invalidScopeItems = this.scopeValidationResults.filter(item => !item.valid)
            if (invalidScopeItems.length === 0) return true;

            for (let i = 0; i < cmp.activeScript.scope_selected_values.length; i++) {
                let element = cmp.activeScript.scope_selected_values[i];
                const hostItem = invalidScopeItems.find(item => item.name === element);
                if (hostItem) {
                    let message = `The ${cmp.getSentenceStart(element)} '${element}' is invalid. Would you like to proceed anyway?`
                    if (hostItem.category === "invalid") message = `'The ${cmp.getSentenceStart(element)} '${element}' is invalid. Would you like to proceed anyway?`
                    if (hostItem.category === "scope") {
                        if (cmp.getSentenceStart(element) === "IP address") message = `'The ${cmp.getSentenceStart(element)} '${element}' is out of scope (you will need to add this as a web app target to your organisation's scope before running a scan). Would you like to proceed anyway?`
                        else message = `'The ${cmp.getSentenceStart(element)} '${element}' is out of scope. Would you like to proceed anyway?`
                    }
                    if (hostItem.category === "resolve") message = `'The ${cmp.getSentenceStart(element)} '${element}' cannot be resolved. Would you like to proceed anyway?`
                    // login_again validation
                    cmp.$dialog.confirm(
                        message,
                        'Scope hosts',
                        function () {
                            // skip dialog
                            cmp.skipScopeSelectedValuesValidation = true;
                            handler();
                        }
                    );
                    return false;
                }
            }
            return true;
        },
        validateLoginAgain: function(script, handler) {
            const cmp = this;
            if (!cmp.activeScript.login_again) return true;
            if (script.includes("def auth.logout")) return true;
            if (cmp.skipLoginAgainValidation) return true;
            let message = "'Replay Login After Confirmation' selected. Please ensure 'def auth.logout' is in your GoScript for this to work correctly. \r\nWould you like to proceed anyway?"
            // login_again validation
            cmp.$dialog.confirm(
                message,
                'Replay Login After Confirmation',
                function () {
                    // skip dialog
                    cmp.skipLoginAgainValidation = true;
                    handler();
                }
            )
            return false;
        },
        validateVariables: function(script, handler) {
            // If the username, password, and login_url match, then they are required. This is how it currently works
            // We prompt for any additional variables. If they are in the table and empty, we proceed without calling an alert.
            // we skip local and regex like variables
            const cmp = this;

            if (script == '') {
                cmp.$flash({
                    type: 'error',
                    message: 'There is no script to run!'
                });
                return
            }
            // extracts variables from the script
            const regex = /{(\w*)}/g;
            const variableMatches = script.match(regex);
            if (variableMatches) {
                // check local variables to skip it
                let localVariables = this.checkLocalVariables(script);
                let regexLikeVariables = this.checkRegexLikeVar(script);
                let missingVariables = [];
                const scriptVariables = variableMatches.map(match => match.slice(1, -1))
                for (let index = 0; index < scriptVariables.length; index++) {
                    const element = scriptVariables[index];
                    if (!cmp.activeScript.variables[element]) {
                        if (cmp.protectedKeys.includes(element)&&cmp.isAuthType)
                        {
                            // check whitelisted username, password and login_url as just being required
                            if (!cmp.isPropertyRequired([element,])) return false;
                        }
                        else {
                            // skip local variables
                            if (localVariables.includes(element)) continue;
                            // skip regex like variables
                            if (regexLikeVariables.includes(element)) continue;
                            // skip the variable if we asked about it before.
                            if (cmp.missingVariablesList.includes(element)) continue;
                            // additional variables can be empty
                            if (!cmp.activeScript.variables.hasOwnProperty(element)) missingVariables.push(element);
                        }
                    }
                }

                if (cmp.skipVarValidation) return true;

                if (missingVariables.length > 0) {
                    const allMissingVariables = missingVariables.join(', ');
                    let message = '';
                    if(missingVariables.length > 1) {
                        message = `The items '${allMissingVariables}' seem to be variables, but their values are not found in the property table. Would you like to proceed anyway?`;
                    } else {
                        message = `The item '${allMissingVariables}' seems to be a variable, but its value is not found in the property table. Would you like to proceed anyway?`;
                    }

                    cmp.$dialog.confirm(
                        message,
                        'Validation Error',
                        function () {
                            // repeat action and skip variable validation
                            cmp.skipVarValidation = true;
                            cmp.missingVariablesList.push(...missingVariables);
                            handler();
                        }
                    )
                    return false;
                }

            }
            return true;
        },
        updateProgress: function (progress) {
            const cmp = this;
            cmp.progress = progress;
            cmp.wizardStatus.progress = cmp.progress;
        },
        calcProgress: function (command, events) {
            // Simple calculation of progress based on the count of functions or events.
            // Progress will be moved to the runner.
            let progress = this.progress;
            let cnt_events = events.length;
            let cnt_funct = 0;

            // count functions (group)
            const groups = new Set();

            events.forEach(event => {
                if (event.group) {
                    groups.add(event.group);
                }
            });

            const size = groups.size;

            if (command === "generate"){
                progress = Math.round((100/20) * cnt_events);
            }
            if (command === "fix"){
                progress = Math.round((100/20) * cnt_events);
            }

            if (command === "test"){
                cnt_funct = 3;
                if (this.activeScript.login_again) cnt_funct = 5;
                progress = Math.round(100/cnt_funct * size);

            }
            if (command === "analyse"){
                cnt_funct = 12;
                progress = Math.round(100/cnt_funct * size);
            }
            if (progress > 90) progress = 90;
            return progress;
        },
        msaRequest: function ({ new_url, status_url, config, success, success_message, fail_message, command, jobId }) {
            var cmp = this;
            cmp.updateRunning(true)

            cmp.$clearAllFlashes();

            if (jobId) {
                cmp.saveLocalStorage(jobId, command, config.use_agentic);
                cmp.startPolling({ jobId, statusUrl: status_url, command, success, failMessage: fail_message });
                return;
            }
            cmp.clearLog();

            // Save the script to local storage if it is unsaved
            cmp.saveLocalStorage();

            Object.assign(config, {
                exchange: cmp.exchange,
                headers: this.activeScript.headers,
                variables: this.activeScript.variables,
                basic_credential_id: this.activeScript.basic_credential_id,
                digest_credential_id: this.activeScript.digest_credential_id,
                ntlm_credential_id: this.activeScript.ntlm_credential_id,
            });

            if (this.activeScript._id) {
                config.script_id = this.activeScript._id;
            };

            // TODO: The properties is deprecated. Use variables instead.
            if (this.activeScript.properties) Object.assign(config, {properties: this.activeScript.variables});
            // Counter for re-running the job when 'Failed to launch job runner' occu
            let jobRetryCount = 0;

            cmp.updateProgress(0)
            var job_poller = function () {
                AjaxUtils.ajax_post({
                    url: new_url,
                    data: JSON.stringify(config),
                    success: function (json) {
                        cmp.updateProgress(5)
                        var id = json.id;
                        cmp.log("id: " + json.id);
                        
                        if (!cmp.activeScript._id) {
                            cmp.jobsToSave.push(id);
                        }
                        if (cmp.$refs.jobhistory) {
                            cmp.$refs.jobhistory.reload();
                        }                        
                        cmp.saveLocalStorage(id, command, config.use_agentic);
                        cmp.startPolling({
                            jobId: id,
                            statusUrl: status_url,
                            command: command,
                            success: success,
                            failMessage: fail_message,
                            onJobRetry: function() {
                                if (jobRetryCount < cmp.maxRetriesOnFail) {
                                    jobRetryCount = jobRetryCount + 1;
                                    setTimeout(job_poller, cmp.pollInterval);
                                    cmp.log(`Retrying the job... Attempt ${jobRetryCount} of ${cmp.maxRetriesOnFail}.`, 'log_notice');
                                    if (cmp.$refs.jobhistory) {
                                        cmp.$refs.jobhistory.reload();
                                    }                        
                                }
                            }
                        });
                    },
                    fail: function (data, status, xhr) {
                        cmp.updateRunning(false);
                        cmp.running = false;
                        cmp.statusStatus = 'fail';
                        cmp.statusResult = '';
                        if (cmp.isStandalone && xhr.status === 200) {
                            //  try to detect when we need to redirect due to an expired session
                            //  TODO: check the active session in a different way

                            let contentType = xhr.getResponseHeader('Content-Type');
                            if (contentType.indexOf('application/json') !== -1) return;

                            if (cmp.activeScript._id) {
                                window.parent.location.href = `/goscript/${cmp.activeScript._id}`;
                            } else {
                                window.parent.location.href = '/goscript/'
                            }
                        }
                    }
                });
            }
            // Start the job polling process
            // Usually, we run the job only once. We repeat the job if the message 'Failed to launch job runner' occurs
            job_poller();
        },
        onTestComplete: function (json) {
            if ('events' in json) {
                if (json.error) {
                    // this.log(json.error);
                    this.statusResult = 'error';
                    let message = json.error;
                    if (json.error && json.message) {
                        message = json.message;
                    }
                    this.$flash({
                        type: 'error',
                        message: message
                    });
                }

                if (!json.error) {
                    this.wizardStatus.test = true;
                    this.wizardStatus.testName = 'GoScript completed successfully';

                    this.statusResult = 'success';
                    this.$flash({
                        type: 'success',
                        message: 'GoScript completed successfully'
                    });
                    this.log('GoScript completed successfully', 'log_success');
                }
            } else {
                //Some sort of fall back or error notice??
                this.statusResult = 'error';
                this.wizardStatus.test = false;
                this.$flash({
                    type: 'error',
                    message: 'GoScript completed without snapshots'
                });
            }
        },
        onAnalyseComplete: function (json) {
            // this.authProfile = json.auth_profile;
            this.authProfileMessage = json.message;

            if(!json.error) {

                this.wizardStatus.analyse = true;

                let success_message = "GoScript was analysed successfully";
                this.statusResult = ""
                if (json.message.includes("Auth detected")) {
                    this.statusResult = "Auth detected";
                    this.log(success_message, "log_success");
                    this.$flash({
                        type: 'success',
                        message: success_message
                    });
                }
                if (json.message.includes("Auth Mechanism NOT DETERMINED")) {
                    this.statusResult = "Auth Mechanism NOT DETERMINED";
                    success_message = "Auth Mechanism NOT DETERMINED";
                    this.log(success_message, "log_warning");
                    this.$flash({
                        type: 'warning',
                        message: success_message
                    });
                }
                this.wizardStatus.analyseName = success_message;
                this.log(json.message);
                this.handleAuthNarrative();
            }
            else this.wizardStatus.analyse = false;
        },
        onGenerateComplete: function (json) {
            if (json.script)
                this.codemirror.setValue(json.script);

            if (!json.error) {
                this.$flash({
                    type: 'success',
                    message: json.message
                });
                this.wizardStatus.generate = true;
                this.saveLocalStorage();
            }
            else {
                this.wizardStatus.generate = false
            }
            this.wizardStatus.generateName = json.message;
        },
        analyseScript: function () {
            this.analyseScriptJob();
        },
        analyseScriptJob: function (jobId = null) {
            if (this.isRunning())
                return

            const cmp = this;
            const command = "analyse";
            cmp.wizardStatus.command = command;

            var script = this.codemirror.getValue();
            if (!jobId) {
                if (!this.validateVariables(script, this.analyseScript)) return
                if (!this.validateAnyScopeSelected(this.analyseScript)) return
                if (!this.validateScopeSelectedValues(this.analyseScript)) return
                this.skipScopeSelectedValuesValidation = false;
                this.skipAnyScopeSelectedValidation = false;
                this.skipVarValidation = false;
            }

            this.runningName = "Analysing auth script, please wait";
            this.statusCommand = "analyse auth script";
            this.statusStatus = '';
            this.statusResult = '';
            var new_url = '/goscript/analyse/new';
            var status_url = '/goscript/analyse/';

            const config = {
                script,
                scope_selected_values: this.activeScript.scope_selected_values,
            }

            this.msaRequest({
                new_url,
                status_url,
                config,
                jobId: jobId || undefined,
                success: function (json) {
                    cmp.onAnalyseComplete(json);
                },
            });
        },
        generateScript: function (useAgentic = false) {
            this.generateScriptJob(useAgentic);
        },
        generateScriptJob: function (useAgentic = false, jobId = null, isFixingScript = false) {
            if (this.isRunning())
                return
            var cmp = this;            
            const config = {};

            let command = "generate";
            this.runningName = "Generating auth script, please wait";
            this.statusCommand = "generate auth script";
            if (isFixingScript) {
                command = "fix";
                this.runningName = "Fixing auth script, please wait";
                this.statusCommand = "fix auth script";                
                config['script'] = this.codemirror.getValue();
            }

            cmp.wizardStatus.command = command;            
            this.statusStatus = '';
            this.statusResult = '';
            var new_url = '/goscript/generate/new';
            var status_url = '/goscript/generate/';

            if (useAgentic) {
                // Use a separate running flag so the editor mask stays disabled
                this.llmRunning = true;
                // We show the running mask until the first script appears.
                this.llmRunningMask = true;
                this.statusCommand = "generate auth script with AI";
                this.openTab(4);
                config["use_agentic"] = useAgentic;
            }

            if (!jobId) {
                if (!this.isPropertyRequired(["login_url", "username", "password"]))
                    return

                if (useAgentic) {
                    if (!this.canUsePrivateHub) {
                        cmp.$dialog.alert(
                            'Only available on public hubs.',
                            'Validation Error'
                        );
                        return;
                    }

                    // update scope, add host from login url if scope is empty
                    const login_url = this.activeScript.variables.login_url;
                    let host = cleanHostName(login_url)
                    if (!this.activeScript.scope.includes(host)) {
                            this.activeScript.scope.push(host);
                        }
                    if (!this.activeScript.scope_selected_values.includes(host)) {
                        this.activeScript.scope_selected_values.push(host);
                    }
                    config["scope_selected_values"] = this.activeScript.scope_selected_values
                }
            }

            this.msaRequest({
                new_url,
                status_url,
                config,
                jobId: jobId || undefined,
                success: function (json) {
                    cmp.onGenerateComplete(json);
                },
                command
            });
        },
        testScript: function () {
            this.testScriptJob();
        },
        testScriptJob: function (jobId = null) {
            if (this.isRunning())
                return

            var cmp = this;
            const command = "test";
            cmp.wizardStatus.command = command;
            var script = this.codemirror.getValue();
            if (!jobId) {
                // TODO: refactor validation
                if (!this.validateVariables(script, this.testScript)) return
                if (!this.validateLoginAgain(script, this.testScript)) return
                this.skipVarValidation = false;
                this.skipLoginAgainValidation = false;
            }

            this.runningName = "Running script, please wait";
            this.statusCommand = "test script";
            this.statusStatus = '';
            this.statusResult = '';
            cmp.updateRunning(true);
            // this.events = [];

            var new_url = '/goscript/test/new';
            var status_url = '/goscript/test/';

            const config = {
                script,
                login_again: this.activeScript.login_again,
            }

            this.msaRequest({
                new_url,
                status_url,
                config,
                jobId: jobId || undefined,
                success: function (json) {
                    if (json.status == 'complete') {
                        cmp.onTestComplete(json);
                    }
                },
                command
            });
        },
        saveScript: function () {
            if (this.isRunning())
                return
            var cmp = this;
            var url = this.url;

            // Save the script to local storage
            cmp.saveLocalStorage();

            // save variables without secrets, unless they are credman credentials
            let variables = {};
            for (let key in cmp.activeScript.variables) {
                if (cmp.protectedKeys.includes(key) && cmp.activeScript.variables[key].type !== 'credential') {
                    variables[key] = '';
                } else {
                    variables[key] = cmp.activeScript.variables[key];
                }
            }

            let scriptValue = this.codemirror.getValue();
            // Convert tabs to spaces on save
            scriptValue = scriptValue.replace(/\t/g, "    ");

            var data = {
                name: this.activeScript.name,
                script: scriptValue,
                variables: variables,
                headers: this.activeScript.headers,
                type: this.activeScript.type,
                login_again: this.activeScript.login_again,
                scope: this.activeScript.scope,
                scope_selected_values: this.activeScript.scope_selected_values,
                hub_id: this.getHubIdByName(this.exchange),
                basic_credential_id: this.activeScript.basic_credential_id,
                digest_credential_id: this.activeScript.digest_credential_id,
                ntlm_credential_id: this.activeScript.ntlm_credential_id,
                jobs_to_save: this.jobsToSave,
            };
            // TODO: The properties is deprecated. Use variables instead.
            if (this.activeScript.properties) data.properties = variables;

            if (!this.activeScript.name) {
                cmp.$dialog.alert(
                    'GoScript has not been named',
                    'Validation Error'
                );
                return;
            }

            AjaxUtils.ajax_post({
                url: url,
                data: JSON.stringify(data),
                success: function (data) {
                    cmp.$dialog.alert(
                        'GoScript has been saved successfully',
                        'GoScript Saved'
                    );

                    cmp.clearLocalStorage();
                    cmp.jobsToSave = [];

                    if (!cmp.activeScript._id)
                    {
                        // new GoScript saved
                        if (cmp.isStandalone)
                        {
                            cmp.activeScript._id = data.goscript._id;
                            window.parent.history.pushState({}, "", `/goscript/${data.goscript._id}`);
                            return;
                        }
                        // TODO: url resolver && add history state to save log/snapshots
                        cmp.$router.replace({
                            name: 'goscript.edit',
                            params: {
                                script_id: data.goscript._id
                            }
                        });
                    }

                },
                fail: function () {
                    cmp.$dialog.alert(
                        'Failed to save the goscript!',
                        'GoScript failed'
                    );
                    cmp.saveLocalStorage();
                }
            });
        },
        clearScript: function () {
            if (this.isRunning())
                return
            this.codemirror.setValue('');
        },
        deleteScript: function () {
            if (this.isRunning())
                return
            const cmp = this;
            if (this.activeScript._id) {
                cmp.$dialog.confirm(
                    'Are you sure you want to delete this GoScript?',
                    'Delete GoScript?',
                    function () {
                        AjaxUtils.ajax_post({
                            url: '/goscript/delete/' + cmp.activeScript._id,
                            success: function (data) {
                                cmp.$dialog.alert(
                                    'GoScript has been deleted successfully',
                                    'GoScript Deleted'
                                );

                                if (cmp.isStandalone)
                                {
                                    window.parent.location.href=`/goscript`
                                    return;
                                }

                                cmp.$router.push({
                                    name: 'goscript.list',
                                });

                            }, fail: function () {
                                cmp.$dialog.alert(
                                    'Failed to delete the goscript!',
                                    'GoScript failed'
                                );
                            },
                            opts: { flash_form_errors: false, flash_404_errors: false }
                        });
                    });
            }
        },
        completeWizard: function() {
            // this.activeScript.variables = {...this.activeScript.variables};
            // this.activeScript.scope = {...this.activeScript.scope};
            // this.activeScript.scope_selected_values = [...this.activeScript.scope_selected_values];
        },
        runWizard: function () {
            const cmp = this;
            cmp.wizardStatus.exchange = cmp.exchange;
            this.$lightbox.open({
                title: 'GoScript Wizard',
                size: 'wide',
                position: 'top',
                component: GoScriptWizardModal,
                shadowPrompt: true,
                bind: {
                    'events': cmp.events,
                    'active-script': cmp.activeScript,
                    'running': cmp.running,
                    'wizard-status': cmp.wizardStatus,
                    'exchanges': cmp.exchanges,
                    'exchange': cmp.exchange,
                    'protected-keys': cmp.protectedKeys,
                },
                on: {
                    'log-screenshot': cmp.clickLogScreenshot,
                    'test-script': cmp.testScript,
                    'generate-script': cmp.generateScript,
                    'analyse-script': function () {
                        // TODO: validate scope values in the wizard
                        cmp.skipScopeSelectedValuesValidation = true;
                        cmp.analyseScript();
                    },
                    'complete': cmp.completeWizard,
                    'clear-log': cmp.clearLog,
                    'save': cmp.saveScript,
                    'update-exchange': function (val) {
                        cmp.exchange = val;
                    }
                }
            });
            return
        },
        maximizePane: function ($event) {
        },
        maximizeMinimizePane: function () {
            if (this.paneSize >= 98) this.paneSize = this.initialPaneSize
            else this.paneSize = 100;
        },
        resizePane: function () {
            if (this.running)
                this.$refs.editorMask.getComponent();
        },
        resizedPane: function () {
            this.bottomHeight = this.$refs.goscriptBottom.getBoundingClientRect().height;
            this.sidebarHeight = this.$refs.goscriptSidebar.getBoundingClientRect().height;
        },
        initPane: function () {
            this.$nextTick(() => {
                this.resizedPane();
            });
        },
        log: function (text, logType) {
            // TODO: Should we add colors for error/info/warning?
            this.console.push(text);
            if (!logType) logType = "log_info";
            this.addEvent(text, logType);
        },
        exportLog() {
            const lines = this.events.map((item) => `${item.data}`);
            const content = new Blob([lines.join('\n')], { type: 'text/plain' });
            const url = URL.createObjectURL(content);
            const a = document.createElement('a');
            a.href = url;
            if (this.activeScript.name) {
                a.download = `${this.activeScript.name} AI-Output`;
            } else {
                a.download = 'GoScript-AI-Output.txt';
            }
            a.click();
            URL.revokeObjectURL(url);
        },
        clearLog: function () {
            this.progress = 0;
            this.wizardStatus.progress = 0;
            this.console = [];
            // this.events = [];
            this.events.length = 0;
            this.llmEvents = [];
            this.authProfile = {};
            this.authProfileMessage = "";
            this.statusCommand = "";
            this.lineErrorNo = null;

            // this.statusCommand = "";
            this.statusResult = "";
            this.statusStatus = "";

            this.narrative = null;
        },
        selectTab: function (value) {
            this.activeTab = value;
        },
        openTab: function (index) {
            this.$refs.goscripttabsref.selectTab(index);
        },
        changeGoScript: function () {
            // We reset this status after saving the GoScript
            // We use it to check if we need a backup
            const cmp = this;
            this.isScriptChanged = true;
            // reset errors
            if (this.lineErrorNo !== null) {
                cmp.codemirror.removeLineClass(this.lineErrorNo, 'background', 'code-editor-line-error');
                this.lineErrorNo = null;
            }
        },
        getLocalStorageKey: function (value) {
            if (!this.$permissions?.me) return;
            return `goscript-${this.$permissions.me}`;
        },
        clearLocalStorage: function (value) {
            const storageKey = this.getLocalStorageKey();
            if (!storageKey)
                // We don't load/save if we cannot use the user id.
                return;
            localStorage.removeItem(storageKey);
            this.isScriptChanged = false;
        },
        loadWithoutStorage: function() {
            this.checkLatestJob().then(restored => {
                if (!restored && !this.activeScript._id)
                    this.openTemplateModal();
            });
            this.applyExchange(this.activeScript.hub_id);
        },
        loadLocalStorage: function () {
            const storageKey = this.getLocalStorageKey();
            if (!storageKey)
                // We don't load/save if we cannot use the user id.
                return;

            const cmp = this;
            const goscript = localStorage.getItem(storageKey);
            if (goscript != null) {
                const data = JSON.parse(goscript);

                // If we don't have a backup for this GoScript.
                if (this.activeScript._id != data.goscript_id && this.activeScript._id) {
                    // We call exchange loading here because we don't want to duplicate dialogs.
                    this.loadWithoutStorage();
                    return;
                }

                // We restore the goscript for new unsaved goscript.
                // We suggest restoring the existing goscript either in a new goscript or in the existed goscript itself.
                // Currently, jobs can only be restored within 1 hour.
                let subject = 'Would you like to restore the unsaved GoScript?';
                if (data.goscript_name)
                    subject = `Would you like to restore the unsaved GoScript, ${data.goscript_name}?`;
                cmp.$dialog.confirm(
                    subject,
                    'GoScript',
                    function () {
                        cmp.codemirror.setValue(data.goscript);

                        if (data.variables) {
                            // If we have property values in activeScript, let's add them
                            for (let key in data.variables) {
                                if (cmp.activeScript.variables[key]) {
                                    data.variables[key] = cmp.activeScript.variables[key];
                                }
                            }
                            cmp.activeScript.variables = data.variables;
                        }
                        if (data.headers) {
                            // If we have header values in activeScript, let's add them
                            for (let key in data.headers) {
                                if (cmp.activeScript.headers[key]) {
                                    data.headers[key] = cmp.activeScript.headers[key];
                                }
                            }
                            cmp.activeScript.headers = data.headers;
                        }

                        if (data.scope) cmp.activeScript.scope = data.scope;
                        if (data.hub_id)
                            {cmp.applyExchange(data.hub_id)}
                        else {cmp.exchange = "";}
                        if (data.scope_selected_values) cmp.activeScript.scope_selected_values = data.scope_selected_values;

                        if (data.basic_credential_id != undefined) cmp.activeScript.basic_credential_id = data.basic_credential_id;
                        if (data.digest_credential_id != undefined) cmp.activeScript.digest_credential_id = data.digest_credential_id;
                        if (data.ntlm_credential_id != undefined) cmp.activeScript.ntlm_credential_id = data.ntlm_credential_id;

                        localStorage.removeItem(storageKey);
                        cmp.$flash({ message: 'GoScript has been restored.' });

                        cmp.checkLatestJob(data.job_id);
                    },
                    function () {
                        cmp.loadWithoutStorage();
                        localStorage.removeItem(storageKey);
                    }
                );
            }
            else {cmp.loadWithoutStorage();}
        },
        saveLocalStorage: function (jobId, jobCommand, useAgentic) {
            const cmp = this;

            const storageKey = this.getLocalStorageKey();
            if (!storageKey)
                return;

            // If the session has expired or script unsaved, we save the current GoScript.
            if (!this.isScriptChanged) return;

            const goscript = this.codemirror.getValue();
            if (goscript) {
                const data = {
                    goscript: goscript,
                };
                if (jobId) {
                    data.job_id = jobId;
                    data.job_command = jobCommand;
                    data.job_saved_at = Date.now();
                    if (useAgentic) data.use_agentic = true;
                };
                if (this.activeScript._id) {
                    data.goscript_id = this.activeScript._id;
                    data.goscript_name = this.activeScript.name;
                };
                //  save the object template without including its values, unless they are from credman
                if (this.activeScript.variables) {
                    let variables = {};
                    Object.keys(this.activeScript.variables).forEach(key => {
                        if (cmp.protectedKeys.includes(key) && cmp.activeScript.variables[key].type !== 'credential') {
                            variables[key] = '';
                        } else {
                            variables[key] = cmp.activeScript.variables[key];
                        }
                    });
                    data.variables = variables;
                };
                if (this.activeScript.headers) {
                    let headers = {};
                    Object.keys(this.activeScript.headers).forEach(key => {
                        headers[key] = '';
                    });
                    data.headers = headers;
                };

                data.scope = this.activeScript.scope;
                data.hub_id = this.getHubIdByName(this.exchange);
                data.scope_selected_values = this.activeScript.scope_selected_values;

                data.basic_credential_id = this.activeScript.basic_credential_id;
                data.digest_credential_id = this.activeScript.digest_credential_id;
                data.ntlm_credential_id = this.activeScript.ntlm_credential_id;

                localStorage.setItem(storageKey, JSON.stringify(data));
            }
        },
        startPolling: function({ jobId, statusUrl, command, success, failMessage, onJobRetry }) {
            const cmp = this;
            let retryCount = 0;
            let progress = 0;

            // Pass the GoScript ID to save it to the job
            // in case the GoScript was saved during job execution.
            const data = {}
            if (this.activeScript._id) {
                data.script_id = this.activeScript._id;
            };
            var poller = function () {

                AjaxUtils.ajax_post({
                    url: statusUrl + jobId,
                    data: JSON.stringify(data),
                    success: function (json) {
                        if ('events' in json) {
                            progress = cmp.calcProgress(command, json.events)
                            cmp.updateProgress(progress);
                            cmp.updateEvents(json.events);
                        };
                        if (json.status == 'complete') {
                            cmp.log("status: complete", "log_notice");
                            cmp.statusStatus = 'complete';
                            // cmp.log(json.message);
                            var custom_fail_message = failMessage ? failMessage : json.message;

                            // Re-run the job when 'Failed to launch job runner' occurs
                            if (json.error) {
                                if (json.error === 'Failed to launch job runner' && onJobRetry) {
                                    onJobRetry();
                                    return;
                                }
                            }

                            if (json.error) {cmp.statusResult = 'error';}
                            else {cmp.statusResult = 'success';}

                            if (json.error && custom_fail_message) {
                                cmp.$flash({
                                    type: 'error',
                                    message: custom_fail_message
                                });
                            }

                            cmp.updateRunning(false);
                            success(json);
                            cmp.highlightLogError();
                            if (cmp.$refs.jobhistory) {
                                cmp.$refs.jobhistory.reload();
                            }                        
                        } else {
                            // status: ongoing, pending
                            // We output to the log only if the status has changed.
                            if(json.status!=cmp.statusStatus) cmp.log("status: " + json.status);
                            cmp.statusStatus = json.status;
                            if ('is_timeout' in json) {
                                // If we cannot get results, we'll try again with an interval * 2.
                                setTimeout(poller, cmp.pollInterval*2);
                            }
                            else {
                                setTimeout(poller, cmp.pollInterval);
                            }
                        }
                    },
                    fail: function () {
                        if (retryCount < cmp.maxRetriesOnFail ) {
                            // If it fails during the run, we'll make some retries with an interval*3.
                            retryCount = retryCount + 1;
                            setTimeout(poller, cmp.pollInterval*3);
                            return;
                        };
                        cmp.statusStatus = 'fail';
                        cmp.statusResult = '';
                        cmp.$flash({
                            type: 'error',
                            message: 'Server connection error or request rejected'
                        });
                        cmp.log('Error contacting server', 'log_error');
                        cmp.updateRunning(false);
                    },
                    opts: { flash_form_errors: false, flash_404_errors: false }
                }).always(function () {
                    // cmp.running = false;
                });
            };
            setTimeout(poller, cmp.pollInterval);
        },
        highlightLogError(){
            const errorLogItem = this.events.find((item) => (item.type === "log_error" && item.lineno));
            if (errorLogItem) this.clickLogError(errorLogItem);
        },
        clickLogError(item) {
            // error highlighting
            let lineno = item.lineno;
            let column =item.column;
            this.codemirror.focus();
            this.codemirror.setCursor({ line: lineno - 1, ch: column });
            this.lineErrorNo = lineno - 1;
            this.codemirror.addLineClass(this.lineErrorNo, 'background', 'code-editor-line-error');
        },
        clickLlmLogError(event) {
            const index = this.llmEvents.findIndex((f) => f.id === event.id);

            let scriptEvent = null;
            for (let i = index - 1; i >= 0; i--) {
                if (this.llmEvents[i].type === 'script') {
                    scriptEvent = this.llmEvents[i];
                    break;
                }
            }
            if (!scriptEvent) return;

            this.clickLogScript(scriptEvent, event);
        },
        openSnapshot(events, id) {
            // Search the next snapshot after the element to open it
            const log_index = events.findIndex((f) => f.id === id);
            let snapshotId = null;
            for (let i = log_index + 1; i < events.length; i++) {
                if (events[i].type === 'snapshot') { snapshotId = events[i].id; break; }
            }
            if (!snapshotId) return;
            this.$lightbox.open(
                {
                    title: "Snapshots",
                    size: "snapshot",
                    position: "top",
                    component: ApckSnapshotsModal,
                    bind: {
                        "events": events,
                        "snapshot-id": snapshotId
                    }
                }
            );
        },
        clickLogScreenshot(id) {
            this.openSnapshot(this.events, id);
        },
        clickLlmLogScreenshot(id) {
            this.openSnapshot(this.llmEvents, id);
        },
        clickLogScript(event, errorEvent = null) {
            const cmp = this;
            const index = this.llmEvents.findIndex(
                (f) => f.id === event.id,
            );
            let original = ""
            for (let i = index - 1; i >= 0; i--) {
                if (this.llmEvents[i].type === 'script') {
                    original = this.llmEvents[i].data;
                    break;
                }
            }
            this.$lightbox.open(
                {
                    title: "GoScript Changes",
                    size: "wide",
                    position: "top",
                    component: ApckGoScriptDiffModal,
                    bind: {
                        "value": event.data,
                        "original": original,
                        "lineno": errorEvent?.lineno,
                        "column": errorEvent?.column,
                    }
                }
            );
        },
        getStatusStyle(status) {
            if (!status) return "";
            const statusClass = status.toLowerCase().replace(/\s+/g, '-');
            return `status-bar__item--${statusClass}`;
        },
        processScriptEvent(event) {
            if (event.type === 'ai_script') {
                this.codemirror.setValue(event.data);
                this.llmRunningMask = false;
                return;
            }
        },
        checkAIFeatures() {
            if (this.$permissions?.enable_ai_features) return true;
            if (this.$permissions?.role_is_admin) {
                this.$dialog.alert(
                    `AI features are disabled. Enable them in Organisation Settings to continue.`,
                    'AI Features'
                );
            }
            else {
                this.$dialog.alert(
                    `AI features are disabled for your organisation. Please contact your Organisation Admin to enable them.`,
                    'AI Features'
                );
            }
            return false;
        },
        fixScriptAI: function () {
            if (this.isRunning())
                return
            this.openGenerateModal(true, true);
        },

        generateScriptAI() {
            if (this.isRunning())
                return

            this.openGenerateModal(true);
        },
        openGenerateModal(useAgentic = false, isFixingScript = false) {
            const cmp=this;
            if (useAgentic) {
                if (!this.checkAIFeatures()) return;
            }

            const title = isFixingScript
                ? 'Configure Script Fix'
                : 'Configure Script Generation';           

            this.$lightbox.open({
                title,
                size: 'normal',
                position: 'top',
                component: GoScriptGenerateModal,
                bind: {
                    'active-script': cmp.activeScript,
                    'protected-keys': cmp.protectedKeys,
                    'is-fixing-script': isFixingScript,
                },
                on: {
                    'generate': function () {
                        cmp.generateScriptJob(useAgentic, null, isFixingScript);
                    }
                }
            });
        },
        addDemoEvents() {
            // temporary method for test purposes
            // this.updateEvents(NEW_LOG_EVENTS);
        }
    },
    template: `
        <apck-panel class="goscript-editor fill-panel" :title="title" :noPadding="true" :noBorder="true">

            <template v-slot:tbar>
                <apck-toolbar class="toolbar-top">
                    <apck-field>
                        <input type="text" v-model="activeScript.name" placeholder="Script Name" ref="scriptName" />
                    </apck-field>

                    <apck-field>
                        <select v-model="activeScript.type" ref="scriptType" class="showme-type">
                            <option value="auth" :selected="activeScript.type === 'auth'">
                                Authentication
                            </option>
                            <option value="workflow" :selected="activeScript.type === 'workflow'">
                                Workflow
                            </option>
                        </select>
                    </apck-field>

                    <apck-button title="Save" icon="fa-save" class="btn-positive" :handler="saveScript" />

                    <apck-sep />

                    <apck-field>
                        <select v-model="exchange" ref="exchange" class="showme-hubs">
                            <optgroup
                                v-if="exchanges.length > 0"
                                label="Internal hubs"
                            >
                                <option
                                    v-for="exchange in exchanges"
                                    :value="exchange.name">
                                        {{exchange.hub_id}}
                                </option>
                            </optgroup>
                            <optgroup label="External hubs">
                                <option value="">
                                    Random external hub
                                </option>
                            </optgroup>
                        </select>
                    </apck-field>

                    <apck-button title="Test" icon="fa-play" class="btn-primary showme-test" :handler="testScript" />
                    <apck-sep />
                    <apck-button title="Clear" icon="fa-times" class="btn-warning" :handler="clearScript" />
                    <apck-button v-if="activeScript._id" title="Delete" icon="fa-trash" class="btn-negative"
                        :handler="deleteScript" />
                </apck-toolbar>
            </template>

            <splitpanes class="default-theme" v-on:resize="resizePane()">
                <pane>
                    <splitpanes horizontal  v-on:resize="resizePane()" v-on:resized="resizedPane()" v-on:ready="initPane()">
                        <pane :size="100 - paneSize">
                            <div class="goscript-body">
                                <div class="code-editor" ref="editorWrap">
                                    <div class="code-wrapper fill-panel">
                                        <div ref="scriptEditor">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </pane>
                        <pane :min-size="initialPaneSize" :size="paneSize">
                        <div class="goscript-bottom" style="height:100%" ref="goscriptBottom">
                            <apck-tabs
                                v-on:selectTab="selectTab"
                                style="height:100%"
                                ref="goscripttabsref"
                            >
                            <template v-slot:action>
                                <div style="float:right; padding-right:5px;">
                                <div class="status-bar">
                                    <div v-if="statusResult" :class="['status-bar__item', getStatusStyle(statusResult)]"><i>result</i>: <span>{{statusResult}}</span></div>
                                    <div v-if="statusStatus" :class="['status-bar__item', getStatusStyle(statusStatus)]"><i>status</i>: <span>{{statusStatus}}</span></div>
                                    <div v-if="false && statusCommand" class="status-bar__item status-bar__item"><i>command</i>: <span>{{statusCommand}}</span></div>
                              </div>
                                    <a v-show="activeTab === 1 && false" href="javascript:" title="Clear logs" v-on:click="clearLog" class="btn btn-borderless"><i class="fa fa-eraser"></i></a>
                                    <a v-show="(activeTab === 4) && hasLlmEvents" href="javascript:" title="Export logs" v-on:click="exportLog" class="btn btn-borderless"><i class="fa fa-download"></i></a>
                                    <a v-if="false" href="javascript:" title="minimize" value="" icon="fa-window-minimize" class="btn btn-borderless" v-on:click="maximizeMinimizePane" ><span :class="['fa', paneSize==100 ? 'fa-chevron-down' : 'fa-chevron-up']"></span></a>
                                </div>
                            </template>

                                <apck-tab title="Snapshots" :active="true" class="showme-snapshots">
                                    <div class="snapshots-scroll" :style="{ height: bottomHeight + 'px' }">
                                    
                                        <span v-if="running && false">
                                            <i class="fa fa-spinner"></i> Running
                                        </span>
                                        <apck-placeholder v-if="events.length === 0" title="No snapshots yet" description="Click 'Test Script' or 'Analyse auth' to begin" />
                                        <apck-snapshots-gallery v-if="false" :events="events" />
                                        <apck-screencast-thumbnails :events="screencastEvents" attachment-url="/vuln-control/attachment" />
                                    </div>
                                </apck-tab>
                                <apck-tab title="Logs" :active="false" class="showme-logs">
                                    <div class="goscript-log" :style="{ height: bottomHeight + 'px' }">
                                        <apck-placeholder v-if="!hasLogEvents" title="No logs yet" description="Logs will appear here once available" />
                                        <apck-log-console
                                            :events="events"
                                            @log-error="clickLogError"
                                            @log-screenshot="clickLogScreenshot"
                                        />
                                    </div>
                                </apck-tab>

                                <apck-tab title="Auth Profile" :active="false"  class="showme-auth-profile" :badge="profileBadgeClass">
                                    <div class="goscript-log" :style="{ height: bottomHeight + 'px' }">
                                        <apck-placeholder v-if="!authProfileMessage" title="Auth Profile not found" description="Click 'Analyse auth' to view Auth Profile result of analysis" />
                                        <apck-goscript-auth-profile
                                            :showCode = "activeTab === 2"
                                            :message="authProfileMessage"
                                            :profile="authProfile"
                                            :scope-selected-values="activeScript.scope_selected_values"
                                            />
                                    </div>
                                </apck-tab>
                                <apck-tab title="Auth Analysis Narrative" :active="false"  class="showme-auth-narrative" >
                                    <div class="goscript-log" :style="{ height: bottomHeight + 'px' }">
                                        <apck-placeholder v-if="!narrative" title="Auth Analysis Narrative not found" description="Click 'Analyse auth' to view Auth Analysis Narrative" />
                                        <apck-narrative
                                            v-if="narrative"
                                            :narrative="narrative"
                                            attachment-url="/vuln-control/attachment"
                                        >
                                        </apck-narrative>
                                    </div>
                                </apck-tab>
                                <apck-tab v-if="enableGoscriptAI" title="AI Output" :active="false"  class="showme-llm" :icon="llmRunningIcon">
                                    <div class="goscript-log" :style="{ height: bottomHeight + 'px' }">
                                        <apck-placeholder v-if="!hasLlmEvents&&!llmRunning" title="No AI Output yet" description="Click 'Generate with AI' to view it." />
                                        <apck-log-console
                                            v-else
                                            :events="llmEvents"
                                            :running="llmRunning"
                                            runningName="Thinking..."
                                            :show-timestamp="false"
                                            @log-error="clickLlmLogError"
                                            @log-screenshot="clickLlmLogScreenshot"
                                            @log-script="clickLogScript"
                                        />

                                    </div>
                                </apck-tab>
                                <apck-tab title="Job History" :active="false"  class="showme-history">
                                    <div class="goscript-log" :style="{ height: bottomHeight + 'px' }">
                                    <apck-goscript-job-history :url="jobListUrl" v-on:restore="restoreJob" ref="jobhistory" />
                                    </div>
                                </apck-tab>

                            </apck-tabs>
                        </div>
                    </pane>

                    </splitpanes>
                </pane>
                <pane min-size="15" size="15" max-size="22">
                    <div ref="goscriptSidebar" style="height:100%">
                        <div class="goscript-sidebar" :style="{ height: sidebarHeight + 'px' }">
                            <apck-accordion title="Variables" class="showme-variables">
                                <apck-goscript-variables
                                    :active-script="activeScript"
                                    :enable-credential-service="enableCredentialService"
                                    :protected-keys="protectedKeys"
                                />
                            </apck-accordion>
                            <apck-accordion title="Headers" class="showme-headers">
                                <apck-property-table
                                    :value="activeScript.headers"
                                    :key-regex="headersRegex"
                                    confirmation-message="Are you sure you want to delete the header"
                                    confirmation-empty-message="Are you sure you want to delete the unnamed header property?"
                                    confirmation-item="header property"
                                    :is-bulk-mode="false"
                                />
                            </apck-accordion>
                            <apck-accordion
                                v-if="enableCredentialService"
                                title="Network Credentials"
                            >
                                <apck-goscript-network-credentials
                                    :active-script="activeScript"
                                />
                            </apck-accordion>
                            <apck-accordion title="Test Script Settings" class="showme-settings">
                                <apck-field description="This option is recommended to ensure that the auth.login function can correctly handle applications which behave differently the first time a user authenticates with a browser, e.g. Google SSO authentication portals remembering the username and prompting only for password).">
                                    <apck-checkbox
                                        label="Replay login after confirmation"
                                        v-model="activeScript.login_again"
                                    />
                                </apck-field>
                            </apck-accordion>
                            <apck-accordion title="Scan Scope Hosts" class="showme-scope" >
                                    <apck-goscript-scope
                                        v-model="activeScript.scope"
                                        confirmation-message="Are you sure you want to delete the scope host"
                                        confirmation-empty-message="Are you sure you want to delete the unnamed scope host?"
                                        confirmation-item="scope host"
                                        :selected-values.sync="activeScript.scope_selected_values"
                                        :scope-results.sync="scopeValidationResults"
                                    >
                                        <apck-button
                                            slot="actionButtons"
                                            title="Load Organisation Scope"
                                            value="Load Organisation Scope"
                                            icon="fa-circle"
                                            class="btn-property"
                                            :handler="loadOrganisationScope"
                                        />
                                    </apck-goscript-scope
                                    <p>This list is for analysis purposes only, for accurate results it must correspond to the scope specified within the scan configuration and therefore must fall within your organisation's scope.</p>
                            </apck-accordion>
                        </div>
                    </div>
                </pane>
            </splitpanes>

            <template v-slot:bbar>
                <apck-toolbar class="apck-no-background">
                    <apck-button title="Save" value="Save" icon="fa-save" class="btn-positive" :handler="saveScript" />
                    <apck-button title="Clear" value="Clear Script" icon="fa-times" class="btn-warning"
                        :handler="clearScript" />
                    <apck-button v-if="activeScript._id" title="Delete" value="Delete Script" icon="fa-trash" class="btn-negative"
                        :handler="deleteScript" />
                    <apck-sep />
                    <apck-button title="Run wizard" value="Run wizard" icon="fa-magic" class="btn-primary showme-wizard" :handler="runWizard" />
                    <apck-button title="Test" value="Test Script" icon="fa-play" class="btn-primary" :handler="testScript" />
                    <apck-button title="Generate auth" value="Generate auth" icon="fa-bolt" class="btn-primary showme-generate" :handler="() => openGenerateModal()" />
                    <apck-button title="Analyse auth" value="Analyse auth"  icon="fa-flask" class="btn-primary showme-analyse" :handler="analyseScript" />
                    <apck-button v-if="enableGoscriptAI && canUsePrivateHub" title="Generate with AI" value="Generate with AI"  icon="fa-hat-wizard" class="btn-ai" :handler="generateScriptAI" />
                    <apck-button v-if="enableGoscriptAI && !canUsePrivateHub" title="Only available on public hubs" value="Generate with AI"  icon="fa-hat-wizard" class="btn-ai" :disabled="true" />
                    <apck-button v-if="enableGoscriptAI && canUsePrivateHub" title="Fix Script with AI" value="Fix Script with AI"  icon="fa-wrench" class="btn-ai" :handler="fixScriptAI" />
                    <apck-button v-if="enableGoscriptAI && !canUsePrivateHub" title="Only available on public hubs" value="Fix Script with AI"  icon="fa-wrench" class="btn-ai" :disabled="true" />
                    <apck-button v-if="false" title="addDemoEvents" value="addDemoEvents"  icon="fa-wrench" class="btn-ai" :handler="addDemoEvents" />

                    <apck-button title="Templates" value="Templates" icon="fa-file" class="btn-neutral pull-right showme-templates"
                        :handler="openTemplateModal" />

                </apck-toolbar>
            </template>

            <apck-mask :trigger="showRunningMask" :title="progress" :value="runningName" target="editorWrap" ref="editorMask" />

        </apck-panel>
    `
}